"use client";

import Button from "@/components/ui/Button";
import { useTranslations } from "@/i18n/client";
import { useState } from "react";
import { OrdersList } from "./OrdersList";
import styles from "./index.module.css";
import { OrderPaging, useOrders } from "./useOrders";

const Orders = () => {
  const t = useTranslations();

  return (
    <>
      <p>{t("myAccount.accountPage.orders.header")}</p>
      <OrdersLoader />
    </>
  );
};
export default Orders;

const OrdersLoader = ({ from = 0, size = 10 }: OrderPaging) => {
  const [showNextPage, setShowNextPage] = useState(false);
  const { data, isLoading } = useOrders({ from, size });
  const t = useTranslations();

  if (isLoading) return <h3>{t("common.loading")}</h3>;

  const orders = data?.orders;
  const total = data?.ordersPaging.totalSize;
  const hasMore = (orders?.length ?? 0) < (total ?? 0);

  if (!orders?.length && from === 0)
    return <h3>{t("myAccount.accountPage.orders.empty")}</h3>;

  return (
    <>
      {orders && <OrdersList orders={orders} />}
      {hasMore && !showNextPage && (
        <Button
          onClick={() => setShowNextPage(true)}
          className={styles.loadMore}
        >
          {t("common.loadMore")}
        </Button>
      )}
      {showNextPage && <OrdersLoader from={from + size} size={size} />}
    </>
  );
};

export const OrderHistoryPreview = () => {
  const t = useTranslations("myAccount.accountPage");
  const { data } = useOrders({ from: 0, size: 5 });
  const orders = data?.orders;

  return (
    <>
      <div className={styles.orderTitleWrapper}>
        <p className={styles.sectionTitle}>{t("tabs.orderHistory")}</p>
        <Button
          href="/account?tab=orderHistory"
          className={styles.seeAll}
          mode="link"
        >
          See all
        </Button>
      </div>
      <p className={styles.sectionSubHeader}>{t("orders.subHeader")}</p>
      {orders && <OrdersList orders={orders} className={styles.boldElement} />}
    </>
  );
};
